import React from 'react';
import ShipmentCandidateListContainer from '../../containers/shipmentmng/ShipmentCandidateListContainer';

const ShipmentCandidateListPage = () => {
  return <ShipmentCandidateListContainer />;
};

export default ShipmentCandidateListPage;
